import React from "react";

import "./InfoPage.css";

import NatureLogo from "../../assets/images/nature_img.png";
import ManRecycling from "../../assets/images/man-recycling.png";
import { NavLink } from "react-router-dom";

const InfoPage = () => {
  return (
    <div className="InfoPage">
      <div className="background-decoration1"></div>
      <div className="background-decoration2"></div>
      <div className="background-decoration3"></div>

      <div className="InfoPage-desktop">
        <div className="left-info-container">
          <h2>A propos de nous</h2>
          <p>
            <i>
              Vous est-il déjà arrivé de ne pas savoir si votre emballage
              pouvait être recycler ou non?
            </i>
          </p>
          <p>
            Le Petit Recycleur est là pour vous aider à répondre à cette
            question.
          </p>
          <p>
            <span>&#127757;</span> De nos jours le recyclage est plus
            qu'indispensable afin de préserver notre Terre et le futur de nos
            enfants.
          </p>
          <NavLink to="/recycling">
            <button className="btn btn-outline-success">
              En savoir plus sur le recyclage
            </button>
          </NavLink>
          <NavLink to="/contact">
            <button className="btn btn_custom_brown">Nous contacter</button>
          </NavLink>
          <p className="data-info-container">
            Le site Le Petit Recycleur utilise la camera de votre appareil pour
            scanner les codes barres.
            <br />
            Nous ne conservons aucunes données personnelles.
            <br />
            Nos informations sont issues de l'API publique{" "}
            <a
              href="https://fr.openfoodfacts.org/"
              rel="noopener noreferrer"
              target="_blank"
            >
              Open Food Facts
            </a>
            .
          </p>
          <p className="img-info-container">
            Les images présentes sur le site sont libres de droits et
            proviennent de <br />
            <a
              href="https://www.freepng.fr"
              rel="noopener noreferrer"
              target="_blank"
            >
              www.freepng.fr
            </a>{" "}
            et{" "}
            <a
              href="https://pixabay.com/fr/"
              rel="noopener noreferrer"
              target="_blank"
            >
              www.pixabay.com
            </a>
            .
          </p>
        </div>
        <div className="right-info-container">
          <img src={ManRecycling} alt="ecology logo" />
        </div>
      </div>

      <div className="InfoPage-mobile">
        <div className="nature-img-container">
          <img src={NatureLogo} alt="nature logo" />
        </div>
        <div className="mobile-body-container">
          <h2>Qui sommes-nous ?</h2>
          <p>
            <i>
              Vous est-il déjà arrivé de ne pas savoir si votre emballage
              pouvait être recycler ou non?
            </i>
          </p>
          <p>
            Le Petit Recycleur est là pour vous aider à répondre à cette
            question.
          </p>
          <p>
            <span>&#127757;</span>&nbsp; De nos jours le recyclage est plus
            qu'indispensable afin de préserver notre Terre et le futur de nos
            enfants.
          </p>
          <NavLink to="/recycling">
            <button className="btn btn-outline-success">
              En savoir plus sur le recyclage
            </button>
          </NavLink>
          <NavLink to="/contact">
            <button className="btn btn_custom_brown">Nous contacter</button>
          </NavLink>
          <p className="data-info-container">
            Le site Le Petit Recycleur utilise la camera de votre appareil pour
            scanner les codes barres.
            <br />
            Nous ne conservons aucunes données personnelles.
            <br />
            Nos informations sont issues de l'API publique{" "}
            <a
              href="https://fr.openfoodfacts.org/"
              rel="noopener noreferrer"
              target="_blank"
            >
              Open Food Facts
            </a>
            .
          </p>
          <p className="img-info-container">
            Les images présentes sur le site sont libres de droits et
            proviennent de <br />
            <a
              href="https://www.freepng.fr"
              rel="noopener noreferrer"
              target="_blank"
            >
              www.freepng.fr
            </a>{" "}
            et{" "}
            <a
              href="https://pixabay.com/fr/"
              rel="noopener noreferrer"
              target="_blank"
            >
              www.pixabay.com
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
};

export default InfoPage;
